import React from "react";
import {useNavigate} from "react-router-dom";

import {useAuth} from "../../auth/AuthProvider";

// Mui components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";


// Material Dashboard 2 components
import NotificationItem from "materialDashboard/examples/Items/NotificationItem";
import MDAvatar from "materialDashboard/components/MDAvatar";
import MDTypography from "materialDashboard/components/MDTypography";
import {useTranslation} from "react-i18next";


const UserMenu = ({anchorEl, open, onClose, user}) => {
    const {t} = useTranslation(['enums']);
    const auth = useAuth();
    const navigate = useNavigate();

    const handleSignOut = () => {
        auth.logout(() => navigate("/"));
    }

    const handleClickAccount = () => {
        navigate("/users/me");
        onClose();
    }

    const {name, surname, role} = user;
    const initials = name?.length > 0 && surname?.length > 0 ? name.charAt(0) + surname.charAt(0) : "U";

    return <Menu
        anchorEl={anchorEl}
        anchorReference={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
        }}
        open={Boolean(open)}
        onClose={onClose}
        sx={{ mt: 2 }}
    >
        <Stack spacing={1} alignItems="center" px={2} pt={2}>
            <MDAvatar src={""} alt="profile-image" size="xl" shadow="sm" bgColor={"dark"}>
                {initials}
            </MDAvatar>
            <MDTypography variant="h5" fontWeight="medium">
                {name || ""} {surname || ""}
            </MDTypography>
            <MDTypography variant="button" color="text" fontWeight="regular">
                {role ? t(`role.${role}`) : ""}
            </MDTypography>
        </Stack>
        <Divider/>
        <NotificationItem icon={<Icon>account_circle</Icon>} title="Account" onClick={handleClickAccount}/>
        <NotificationItem icon={<Icon>logout</Icon>} title="Logout" onClick={handleSignOut}/>
    </Menu>
}

export default UserMenu;
